module.exports = "https://www.gc-qa.gnp.com.mx/4d4f9fb0864b0b917b2cb843941b3f1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/03-recibo.svg
// module id = 1789
// module chunks = 0